import React from "react";
import PropTypes from "prop-types";
import Btn from "../../../../components/atoms/Btn";

function GraphButton({ onClick, title, children }) {
  return (
    <Btn
      className="hover:tw-opacity-100 tw-w-6 tw-text-center tw-cursor-pointer tw-opacity-70 tw-py-1 color-3"
      onSubmit={onClick}
      data-tooltip={title}
      data-tooltip-class="genome-browser-small-tooltip"
    >
      {children}
    </Btn>
  );
}

GraphButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

GraphButton.defaultProps = {
  onClick: () => {},
  title: "",
};

export default GraphButton;
